<template>
  <div class="x-tablelist-view" data-automation="push">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @input="seach"
      @search="seach"
      @add="showAdd"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :emptyText="$t('HT.nodata')"
        :total="tableData.totalSize"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script>
import addPush from './addPush';
import { getLocalStorage } from '@l/localStorage.js';
export default {
  inject: ['reload'],
  components: {
    addPush
  },
  data() {
    return {
      viewAPI: 'push',
      layout: [], // 搜索项配置
      columns: [
        // 表头数据
        {
          label: '用户名',
          prop: 'user',
          tooltip: true
        },
        {
          label: '类型',
          prop: 'type',
          tooltip: true
        },
        {
          label: '表达式',
          prop: 'expression',
          tooltip: true
        },
        {
          label: '描述',
          prop: 'memo',
          tooltip: true
        },
        {
          label: 'URL',
          prop: 'url',
          tooltip: true
        },
        {
          label: '操作',
          hidden: !this.$hasModule(33),
          width: 250,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: ['编辑', '删除'],
                event: ['edit', 'del']
              },
              on: {
                // 编辑
                edit: () => {
                  this.$uxModal.show({
                    title: '编辑推送配置',
                    content: (h) => {
                      return h(addPush, {
                        props: {
                          data: params
                        }
                      });
                    },
                    confirm: (data) => {
                      this.putList(data);
                    }
                  });
                },
                // 删除
                del: () => {
                  this.$uxModal.show({
                    title: '删除推送配置',
                    content: '确定要删除该推送配置吗？',
                    confirm: () => {
                      this.delList(params);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        user: null, // 用户名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      userData: getLocalStorage('userData')
    };
  },
  created() {
    this.layout = [
      {
        type: 'input',
        key: 'user',
        placeholder: '请输入用户名进行搜索',
        hidden: !this.userData.supervisor,
        hideBtn: false
      },
      {
        type: 'button',
        text: '新增',
        right: this.userData.supervisor,
        hidden: !this.$hasModule(33),
        event: 'add'
      }
    ];
    this.filter.user = this.userData.supervisor ? null : this.userData.username;
    this.getList(this.filter);
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api[this.viewAPI].getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.count,
            list: res.result
          };
        }
      });
    },
    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api[this.viewAPI].addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.filter.user = this.userData.supervisor ? null : this.userData.username;
          this.$uxMessage.success('添加成功');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 编辑列表
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api[this.viewAPI].putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.filter.user = this.userData.supervisor ? null : this.userData.username;
          this.$uxMessage.success('HT.addApi.editSuccess');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(params) {
      this.$uxLoading.show();
      let postData = {
        id: params.id,
        user: params.user
      };
      this.$api[this.viewAPI].delList(postData).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('删除成功');
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },
    /**
     * 新增-弹窗
     */
    showAdd() {
      this.$uxModal.show({
        title: '添加推送配置',
        content: (h) => {
          return h(addPush, {});
        },
        confirm: (data) => {
          this.addList(data);
        }
      });
    },
    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
